import React, { useState } from "react";
import Select from "react-select";

export default function DialogCredit({
  onChange,
  schema,
  client,
  onSubmit,
  initialValues = {},
}) {
  const clientOptions = client
    .filter((c) => c.billingType === "Prepaid")
    .map((c) => ({
      value: c.id,
      label: c.name,
      data: c,
    }));

  const defaultClient = clientOptions.find(
    (opt) => opt.value === initialValues?.client?.id
  );
  const defaultAmount = initialValues?.balance;
  const [selectedClient, setSelectedClient] = useState(defaultClient || null);
  const [amount, setAmount] = useState(defaultAmount);

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
    onChange(selectedOption.data, "client");
  };

  // const handleAmountChange = (e) => {
  //   const value = parseFloat(e.target.value) || 0;
  //   setAmount(value);
  //   onChange(value, "balance");
  // };
  const handleAmountChange = (e) => {
    let inputValue = e.target.value;

    // Remove leading zeros unless the number starts with "0."
    if (/^0[0-9]+/.test(inputValue)) {
      inputValue = inputValue.replace(/^0+/, "");
    }

    const numericValue = parseFloat(inputValue) || 0;
    setAmount(inputValue); // Keep the typed string for UX
    onChange(numericValue, "balance");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit}>
      <p className="fw-bold text-primary" style={{ fontSize: "1.2rem" }}>
        <span className="pe-2">
          <i className="bi bi-credit-card-fill"></i>
        </span>
        Credit Amount
      </p>

      <div className="mb-3">
        <p className="m-0 mb-1" style={{ fontSize: ".875rem" }}>
          Client:
        </p>
        <Select
          options={clientOptions}
          placeholder="Select Prepaid Client"
          onChange={handleClientChange}
          value={selectedClient}
          className="w-100"
          isDisabled
        />
      </div>

      <div className="mb-3">
        <p className="m-0 mb-1" style={{ fontSize: ".875rem" }}>
          Amount:
        </p>
        <input
          type="number"
          className="form-control"
          placeholder="Credit to add"
          value={amount}
          onChange={handleAmountChange}
        />
      </div>

      <div className="text-center mb-2">
        <button type="submit" className="btn btn-primary">
          Save
        </button>
      </div>
    </form>
  );
}
